import { SPANISH_MYSTERIES } from "./rosaryMysteries.es";
import { FRENCH_MYSTERIES } from "./rosaryMysteries.fr";
import { ROSARY_MEANINGS } from "./rosaryMeanings";
import ART from "./rosaryArt.json";

const UI = {
  en: {
    chapter: "Chapter 02 · Pray the Rosary", heading: "Follow the beads", language: "Prayer language",
    decade: "Decade", closingPrayers: "Closing prayers",
    set: "Mystery set", begin: "Begin", of: "of", for: "for", step: "Step", bead: "Bead",
    virtues: ["Faith", "Hope", "Charity"], ordinals: ["First", "Second", "Third", "Fourth", "Fifth"],
    intentions: ["for Faith", "for Hope", "for Charity"],
    meaning: "The meaning of the mystery", scripture: "Scripture meditation · adapted wording", expandArt: "View artwork", artSource: "Artwork source",
    mystery: "Mystery", previous: "Previous", next: "Next bead", restart: "Restart",
    auto: "Auto-advance", pause: "Pause", complete: "Rosary complete", fruit: "Fruit", continueTo: "Continue to",
    jump: "Jump to a mystery", announce: "Announce the mystery", showEnglish: "Show English",
    meditate: "Pause a moment. Picture the scene. Ask for the grace of this mystery",
    opening: "Opening prayers", crucifix: "Crucifix", medal: "Marian medal", diagram: "Interactive Rosary with crucifix and introductory beads",
  },
  la: {
    chapter: "II · Sanctum Rosarium", heading: "Ora nobiscum", set: "Mysteria", language: "Lingua",
    step: "Gradus", of: "ex", previous: "Praecedens", next: "Oravi · Perge", restart: "Ab initio",
    auto: "Progressio automatica", pause: "Siste progressionem", complete: "Rosarium absolutum est. In pace Christi maneas.", continueTo: "Perge:",
    fruit: "Fructus mysterii", contemplation: "Contemplare", mystery: "mysterium", ordinals: ["Primum", "Secundum", "Tertium", "Quartum", "Quintum"],
    meaning: "Sensus mysterii", scripture: "Meditatio Scripturae · verba adaptata", expandArt: "Imaginem aperi", artSource: "Fons imaginis",
    artCaption: "Ars sacra ad mysterium contemplandum", bead: "Grano", diagram: "Rosarium · grana eligere potes", medal: "Imago sacra", crucifix: "Crucifixus",
    opening: "Preces initiales", decade: "Decas", closingPrayers: "Preces finales", showEnglish: "Versio Anglica", announce: "Mysterium annuntia", meditate: "Meditare",
    begin: "Incipe", for: "pro", virtues: ["Fides", "Spes", "Caritas"], intentions: ["pro fide", "pro spe", "pro caritate"], jump: "Mysterium elige",
  },
  es: {
    chapter: "Capítulo 02 · Reza el Rosario", heading: "Sigue las cuentas", language: "Idioma de la oración",
    decade: "Decena", closingPrayers: "Oraciones finales",
    set: "Misterios", begin: "Comenzar", of: "de", for: "por la", step: "Paso", bead: "Cuenta",
    virtues: ["Fe", "Esperanza", "Caridad"], ordinals: ["Primer", "Segundo", "Tercer", "Cuarto", "Quinto"],
    intentions: ["por la Fe", "por la Esperanza", "por la Caridad"],
    meaning: "El significado del misterio", scripture: "Meditación bíblica · texto adaptado", expandArt: "Ver la obra", artSource: "Fuente de la obra",
    mystery: "misterio", previous: "Anterior", next: "Siguiente cuenta", restart: "Reiniciar",
    auto: "Avance automático", pause: "Pausar", complete: "Rosario completado", fruit: "Fruto", continueTo: "Continuar:",
    jump: "Ir a un misterio", announce: "Anuncia el misterio", showEnglish: "Mostrar en inglés",
    meditate: "Haz una pausa. Contempla la escena. Pide la gracia de este misterio",
    opening: "Oraciones iniciales", crucifix: "Crucifijo", medal: "Medalla de María", diagram: "Rosario interactivo con crucifijo y cuentas iniciales",
  },
  fr: {
    chapter: "Chapitre 02 · Priez le Rosaire", heading: "Suivez les grains", language: "Langue de la prière",
    decade: "Dizaine", closingPrayers: "Prières finales",
    set: "Mystères", begin: "Commencer", of: "sur", for: "pour la", step: "Étape", bead: "Grain",
    virtues: ["Foi", "Espérance", "Charité"], ordinals: ["Premier", "Deuxième", "Troisième", "Quatrième", "Cinquième"],
    intentions: ["pour la Foi", "pour l’Espérance", "pour la Charité"],
    meaning: "Le sens du mystère", scripture: "Méditation biblique · texte adapté", expandArt: "Voir l’œuvre", artSource: "Source de l’œuvre",
    mystery: "mystère", previous: "Précédent", next: "Grain suivant", restart: "Recommencer",
    auto: "Avance automatique", pause: "Pause", complete: "Rosaire terminé", fruit: "Fruit", continueTo: "Continuer :",
    jump: "Aller à un mystère", announce: "Annoncez le mystère", showEnglish: "Afficher en anglais",
    meditate: "Prenez un instant. Contemplez la scène. Demandez la grâce de ce mystère",
    opening: "Prières initiales", crucifix: "Crucifix", medal: "Médaille de Marie", diagram: "Rosaire interactif avec crucifix et grains d’introduction",
  },
};

export const rosaryUI = (lang) => UI[lang] || UI.en;
export const localizeSet = (set, lang) => {
  const translated = ({ es: SPANISH_MYSTERIES, fr: FRENCH_MYSTERIES })[lang]?.[set.id];
  const meanings = (ROSARY_MEANINGS[lang] || ROSARY_MEANINGS.en)[set.id];
  const mysteries = translated ? translated.mysteries.map(([title, , , fruit], i) => ({ ...set.mysteries[i], title, fruit })) : set.mysteries;
  return {
    ...set, short: set.label.replace(" Mysteries", ""), ...translated,
    mysteries: mysteries.map((m, i) => ({ ...m, meaning: meanings[i], art: ART[set.id][i] })),
  };
};
export const mysteryLabel = (index, lang) => `${rosaryUI(lang).ordinals[index]} ${rosaryUI(lang).mystery}`;